<template>
    <div class="fixed inset-x-0 bottom-0 px-4 pb-4 z-90 sm:inset-0 sm:flex sm:items-center sm:justify-center">

        <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75">
            </div>
        </div>

        <div class="loader" ></div>
    </div>
</template>

<script>
export default {
  name: "Spinner"
};
</script>

<style>

</style>